import { convertToUsdString } from './convertToUsdString';

/**
 * Converts a subscription amount toward a USD-normalized value using
 * `exchangeRate` (from the user's country). For amounts already in USD
 *  the rate is not applied.
 */
export function convertToUsdNumber(amount: number, exchangeRate: number, subscriptionCurrencyCode: string): number {
	if (subscriptionCurrencyCode.toUpperCase() === 'USD') {
		return amount;
	}
	return Number(convertToUsdString(amount, exchangeRate));
}
